// use-task-queries.js: // Page view for editing a single task in detail.
import { useCallback } from 'react';
import { getTask } from '@/services/taskService';

const useTaskQueries = () => {
  const fetchTaskById = useCallback(async (taskId, userId) => {
    if (!taskId || !userId) return null;
    return await getTask(taskId);
  }, []);

  return { fetchTaskById };
};

export default useTaskQueries;
